import { pick } from 'ramda';
import { useCallback } from 'react';
import { useDeviceSelector } from 'js/store/hooks';

import * as pas from '../pas';
import * as helpers from '../helpers';

export const useBeforeLoginAction = () => {
    const { deviceId, deliveryPlatform, clientPlatform } = useDeviceSelector(pick(['deviceId', 'deliveryPlatform', 'clientPlatform']));

    return useCallback(() => {
        if (deviceId) {
            pas.setDeviceId(deviceId);
        }

        if (deliveryPlatform) {
            pas.setDeliveryPlatform(deliveryPlatform);
        }

        if (clientPlatform) {
            pas.setClientPlatform(clientPlatform);
        }

        const blackbox = helpers.getIovationBlackbox();

        if (blackbox) {
            pas.setIovationBlackbox(blackbox);
        }
    }, [deviceId, deliveryPlatform, clientPlatform]);
};
